/**
 * Formats a number as Euro currency using German locale
 * @param price - The price to format
 * @returns Formatted price string (e.g., "250,00 €")
 */
export function formatPrice(price: number): string {
  // return new Intl.NumberFormat('de-DE', {
  //   style: 'currency',
  //   currency: 'EUR',
  //   minimumFractionDigits: 2,
  //   maximumFractionDigits: 2
  // }).format(price)
  return `${price} EUR`
}
